/**
 * Navegação com recarga completa: descarta caches, contextos e a base do router, que só é
 * lida no arranque. É o que a troca de organização precisa; para o resto, use o router.
 */
export function reloadAt(href: string, { replace = false }: { replace?: boolean } = {}): void {
    if (replace) window.location.replace(href);
    else window.location.assign(href);
}
